import { ComponentInternalInstance, getCurrentInstance } from '@vue/composition-api';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
export interface RouterParams {
  spaceId: string;
  name?: string;
  spaceOrgId?: string;
  groupId?: string;
  id?: string;
  path?: string;
  teamPath?: string;
  teamId?: string;
  isExternal?: string;
}

/**
 * 文件定位处理
 */
export const fileLocationHandler = () => {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const methods = {
    /**
     * group files
     * @param params
     */
    toGroup(params: RouterParams): void {
      dispatchRouter({
        name: 'collaborationSpaceList',
        query: {
          ...params,
        },
      });
    },
    /**
     * team space files
     */
    toTeamSpace(params: RouterParams): void {
      dispatchRouter({
        name: 'teamSpace',
        query: {
          ...params,
        },
      });
    },
  };
  return {
    methods,
  };
};
